import en_US from "antd/lib/date-picker/locale/en_US";
import vi_VN from "antd/lib/date-picker/locale/vi_VN";

export const getLocale = (lang) => {
    switch (lang) {
        case 'en':
            return en_US
        case 'vi':
        default:
            return vi_VN
    }
}